import type { AssignableAsset } from "../domain";

/**
 * Placeholder branches for the mock asset catalog only -- the real Branch
 * filter is `@nasam/core`'s own `BranchesRepository` (see
 * CreateSupervisorAssignmentScreen), not these. Kept private to this file;
 * nothing outside the mock data layer should reference mock branch ids.
 */
const mockBranches = [
  { id: "mock-branch-1", nameEn: "Main Branch - Riyadh", nameAr: "الفرع الرئيسي - الرياض" },
  { id: "mock-branch-2", nameEn: "Jeddah Branch", nameAr: "فرع جدة" },
  { id: "mock-branch-3", nameEn: "Dammam Branch", nameAr: "فرع الدمام" },
  { id: "mock-branch-4", nameEn: "Makkah Branch", nameAr: "فرع مكة المكرمة" },
];

const ASSETS_PER_BRANCH = 7;

export const assetOptionFixtures: readonly AssignableAsset[] = mockBranches.flatMap(
  (branch, branchIndex) =>
    Array.from({ length: ASSETS_PER_BRANCH }, (_, assetIndex) => {
      const serial = branchIndex * ASSETS_PER_BRANCH + assetIndex + 1;
      const name = `شاحنة ${String(serial).padStart(3, "0")}`;
      return {
        id: `asset-${String(serial)}`,
        code: `AST-${String(serial).padStart(6, "0")}`,
        nameEn: name,
        nameAr: name,
        branch,
      };
    }),
);
